import { lazy, useMemo, Suspense } from 'react';
import {
  useUpMedia,
  useSessionIdHandler,
  useGameWebsocketsSubscription,
  useCurrencyManaging,
  useBlockchainDataUpdater,
  useRpcRateLimitHandler,
  useShouldShowB2BRefreshMessage,
  // useResetRaceResultsOnRoundStart,
} from '../hooks';
import { withExampleProvider } from '../components/game-page';
// import { DemoModal } from '../components/modals/DemoModal.tsx';
import { LoadingSpinner } from '../components/spinners';
import { B2BRefreshMessage } from '../components/B2BRefreshMessage';
import { useAutoBlockchainRoundDataUpdater } from '../hooks/useAutoBlockchainRoundDataUpdater.ts';

const DesktopContent = lazy(() =>
  import('../components/game-page/desktop/DesktopContent.tsx').then(
    (module) => ({
      default: module.DesktopContent,
    })
  )
);

const MobileContent = lazy(() =>
  import('../components/game-page/mobile/MobileContent.tsx').then((module) => ({
    default: module.MobileContent,
  }))
);

const GamePageEffectsAndContent = ({ desktop }: { desktop: boolean }) => {
  const content = useMemo(
    () => (
      <Suspense
        fallback={
          <LoadingSpinner
            style={{
              margin: 'auto',
            }}
          />
        }
      >
        {desktop ? <DesktopContent /> : <MobileContent />}
      </Suspense>
    ),
    [desktop]
  );

  useGameWebsocketsSubscription();
  useCurrencyManaging();
  useBlockchainDataUpdater();
  useAutoBlockchainRoundDataUpdater();
  useRpcRateLimitHandler(); // Monitor and handle 429 errors
  // TODO: check if should be removed
  // useResetRaceResultsOnRoundStart();

  return (
    <>
      {content}
      {/* <DemoModal /> */}
    </>
  );
};

const GamePage = withExampleProvider(() => {
  const desktop = useUpMedia('md');
  const shouldShowRefreshMessage = useShouldShowB2BRefreshMessage();

  const { hasSessionIdParam, isHandlingSessionId } = useSessionIdHandler();

  // If we arrived via B2B session link, block game startup until token is resolved.
  if (hasSessionIdParam && isHandlingSessionId) {
    return (
      <LoadingSpinner
        style={{
          margin: 'auto',
        }}
      />
    );
  }

  // Show refresh message instead of game in B2B when no token
  if (shouldShowRefreshMessage) {
    return <B2BRefreshMessage />;
  }

  return <GamePageEffectsAndContent desktop={desktop} />;
});

export { GamePage };
